import React, {ChangeEvent, useRef, useState, useCallback} from 'react';
import {Formik, Form} from 'formik';

import ButtonGroup from './buttonGroup';
import DotsLoading from '../../../../components/dotsLoading';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import CustomAudioPlayer from '../../../../components/mazraeKit/customAudioPlayer';
import {toast} from 'react-toastify';
import useRecorderChat from './helper/useRecorderChat';

import FileCachUpload from './fileCachUpload';
import {IChatReplyState, IImageFileUpload} from '../type';
import {useNavigate, useParams} from 'react-router-dom';
import {usePostSendMesaage} from '../../../../services/hookService/chats/sendMessage/usePostSendMesaage';
import {RootState} from '../../../../store/redux';
import {useDispatch, useSelector} from 'react-redux';
import {clearAllData} from '../../../../store/redux/imageCropping';
import moment from 'jalali-moment';
import ChatFormText from './ChatFormText';
import usePostAddChat from '../../../../services/hookService/chats/usePostAddChat/usePostAddChat';

interface ChatInputAreaProps {
  chatId?: string;
  dropDownIsOpen: boolean;
  file?: File;
  userChatDetailData: IGetUserCHatDetailData | undefined;
  imageFile?: IImageFileUpload;
  supplier_guid?: string;
  replyingChat?: IChatReplyState;
  setReplyingChat: React.Dispatch<
    React.SetStateAction<IChatReplyState | undefined>
  >;
  refresh: () => void;
  onWatchEnd?: () => void;
  setDropDownIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setImageFile: React.Dispatch<
    React.SetStateAction<IImageFileUpload | undefined>
  >;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
}
const ChatInputArea = ({
  refresh,
  file,
  imageFile,
  replyingChat,
  userChatDetailData,
  supplier_guid,
  setReplyingChat,
  setDropDownIsOpen,
  setImageFile,
  setFile,
}: ChatInputAreaProps) => {
  const dispatch = useDispatch();
  const {guid} = useParams();
  const navigate = useNavigate();
  const {cropedImage} = useSelector((state: RootState) => state.imageCropedit);

  const refStream = useRef<MediaStream | undefined>();
  const imageUpload = useRef<HTMLInputElement>(null);
  const fileUpload = useRef<HTMLInputElement>(null);
  const [isOpenPopUp, setisOpenPopUp] = useState(false);

  const mediaRecorder = useRef<MediaRecorder | undefined>();
  const {mutateAddChat} = usePostAddChat({
    onSuccess: data => {
      navigate(`/chat-form/${data.chat_guid}`, {
        state: {
          supplierGuid: supplier_guid,
        },
      });
    },
  });
  const {isLoading, mutate} = usePostSendMesaage({
    guid,
    onSuccess: () => {
      refresh();
      setDropDownIsOpen(false);
      setisOpenPopUp(false);
      setAudioChunks([]);
      setisRecording(false);
      setGeneratedBlob(undefined);
      setTimer(undefined);
      setImageFile && setImageFile(undefined);
      setFile(undefined);
      setReplyingChat(undefined);
      dispatch(clearAllData());
    },
  });
  const {
    audioChunks,
    generatedBlob,
    isRecording,
    timer,
    setAudioChunks,
    setGeneratedBlob,
    setTimer,
    setisRecording,
  } = useRecorderChat();

  const streamGenerator = useCallback(async () => {
    try {
      if (!refStream.current) {
        const stram = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        refStream.current = stram;

        return stram;
      }
    } catch (error) {
      toast.error('میکروفون در دسترس نیست !');
    }
  }, []);

  const onVoiceRecorderHandler = async () => {
    const stream = await streamGenerator();
    if (stream) {
      try {
        setAudioChunks([]);

        mediaRecorder.current = await new MediaRecorder(stream);

        setGeneratedBlob(undefined);
        mediaRecorder.current.ondataavailable = e => {
          if (e.data && e.data.size > 0) {
            setAudioChunks(prev => [...prev, e.data]);
          }
        };

        setisRecording(true);

        await mediaRecorder.current.start(1);
      } catch (error) {
        setisRecording(false);
      }
    }
  };

  const onStopVoiceHandler = async () => {
    if (mediaRecorder.current) {
      mediaRecorder.current.stop();
      mediaRecorder.current.stream.getTracks().forEach(track => track.stop());

      if (audioChunks.length > 0) {
        const blob = new Blob(audioChunks, {type: 'audio/ogg'});
        setisRecording(false);

        setGeneratedBlob(blob);
        refStream.current = undefined;
      }
    }
  };

  const handlerUploadImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.files && event?.target?.files[0]) {
      setDropDownIsOpen(true);
      setisOpenPopUp(false);
      setImageFile && setImageFile({imageFile: event.target.files[0]});
      setFile(undefined);
      if (imageUpload.current) {
        imageUpload.current.value = '';
      }
    }
  };
  const handlerUploadFile = (event: ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.files && event?.target?.files[0]) {
      const match = event?.target?.files[0].type.split('/') || [];
      const type = match[0];

      if (type === 'image' || type === 'video') {
        setDropDownIsOpen(true);
      } else if (event?.target?.files[0].type !== 'application/pdf') {
        toast.error('پسوند فایل باید pdf باشد!');
        return;
      }
      setisOpenPopUp(false);
      setFile(event.target.files[0]);
      setImageFile && setImageFile(undefined);
      if (fileUpload.current) {
        fileUpload.current.value = '';
      }
    }
  };

  const fileSendHandeler = () => {
    if (generatedBlob) {
      return {
        file: new File([generatedBlob], 'voice.ogg'),
        type: 'voice',
        file_length: timer,
      };
    }
    if (imageFile || cropedImage) {
      return {file: cropedImage || imageFile?.imageFile, type: 'image'};
    }
    if (file) {
      const fileType = file.type;
      return {
        file: file,
        type: fileType === 'application/pdf' ? 'pdf' : 'video',
      };
    }

    return {};
  };

  return (
    <div className="rounded  py-2 min-h-[70px] max-h-[120px] z-20 w-full   bg-white  bottom-0 flex justify-center  items-center shadow-[0_-3.28779px_6.57558px_rgba(171,190,209,0.3)] relative">
      <div className="flex flex-col w-full h-fit absolute bottom-[70px] left-0 right-0 px-2 bg-white">
        {replyingChat && (
          <div className="w-full items-center flex justify-between h-[54px]">
            <button
              className="min-w-[40px]"
              onClick={() => setReplyingChat(undefined)}
            >
              <SpanIcon className="icon-nameClose-remove text-xxl" />
            </button>
            <div className="w-full flex flex-col text-gray-700 text-md gap-1 font-Regular justify-center">
              <div className="flex gap-1 ">
                <SpanIcon className="icon-Back" />
                <p className="m-0 p-0">پاسخ به</p>
              </div>
              <p className="w-full text-md font-Regular line-clamp-1 m-0 p-0 text-gray-950">
                {replyingChat.fromReply.title}
              </p>
            </div>
          </div>
        )}
        {file && file.type === 'application/pdf' && (
          <FileCachUpload setFile={setFile} file={file} />
        )}
      </div>
      <Formik
        initialValues={{
          text: '',
        }}
        onSubmit={(values, actions) => {
          const fileData = fileSendHandeler();
          actions.resetForm();
          if (!guid) {
            mutateAddChat({
              message: values.text,
              supplier_guid: supplier_guid!,
            });
          } else
            mutate({
              file: fileData.file,
              file_type: fileData.type,
              file_length: fileData.file_length,
              message: values.text,
              parent_guid: replyingChat?.fromReply.guid || null,
              receiver: userChatDetailData?.receiver_profile.username || '',
            });
        }}
      >
        {({values}) => {
          return (
            <Form className="flex items-center gap-3 w-full justify-center ">
              <div className=" flex justify-center items-center h-full w-[10%]">
                {isLoading ? (
                  <DotsLoading />
                ) : (
                  <>
                    {values.text.length > 0 ||
                    file ||
                    imageFile ||
                    cropedImage ? (
                      <ButtonGroup text={values.text} />
                    ) : (
                      <>
                        {generatedBlob && audioChunks.length !== 0 ? (
                          <button
                            disabled={isLoading}
                            type="submit"
                            className="text-primary flex items-center min-w-[50px] h-[50px] justify-center text-[25px] bg-farm-shop-500 rounded-full"
                          >
                            <SpanIcon className="icon-nameSend text-white text-lg" />
                          </button>
                        ) : (
                          guid && (
                            <div
                              onClick={() => {
                                audioChunks.length === 0
                                  ? onVoiceRecorderHandler()
                                  : onStopVoiceHandler();
                              }}
                              className="text-primary flex items-center min-w-[50px] h-[50px] justify-center text-[25px] bg-farm-shop-500 rounded-full"
                            >
                              <SpanIcon className="icon-namerecord text-white text-lg" />
                            </div>
                          )
                        )}
                      </>
                    )}
                  </>
                )}
              </div>

              <div className=" flex text-black items-center justify-center gap-2 w-[75%] ">
                {audioChunks.length !== 0 ? (
                  <div className="flex items-center gap-1 w-full justify-end">
                    {generatedBlob && (
                      <>
                        <CustomAudioPlayer
                          timer={timer}
                          url={URL.createObjectURL(generatedBlob)}
                        />
                      </>
                    )}

                    <div className="flex items-center gap-1 text-gray-700">
                      {timer && moment.utc(timer).format('mm:ss')}
                      {isRecording ? (
                        <div className="flex w-[7px] h-[7px] rounded-full bg-[red]"></div>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            setAudioChunks([]);
                            setGeneratedBlob(undefined);
                            setTimer(undefined);
                          }}
                        >
                          <SpanIcon className="icon-nameDelete text-xxl text-red-700" />
                        </button>
                      )}
                    </div>
                  </div>
                ) : (
                  <ChatFormText
                    fileUpload={fileUpload}
                    imageUpload={imageUpload}
                    isOpenPopUp={isOpenPopUp}
                    setisOpenPopUp={setisOpenPopUp}
                    handlerUploadImage={handlerUploadImage}
                    handlerUploadFile={handlerUploadFile}
                    chatId={guid}
                  />
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ChatInputArea;
